import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { useMapping } from '../lib/use-mapping';
import {
  PageHeader,
  MappingStats,
  LocationsOverview,
  TransportRoutes,
  LocationStatistics,
  InteractiveMapPlaceholder
} from './components';

export function MappingPage() {
  const { t } = useTranslation();
  const { data, stats, locationsByType, error, getLocationIcon, getLocationTypeColor, formatNumber } = useMapping();

  if (error) {
    return (
      <div className="p-6">
        <Card className="p-6">
          <p className="text-destructive">Error loading mapping data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <PageHeader title={t('welcome_mapping_label', 'Mapping')} />

      {stats && <MappingStats stats={stats} />}

      {data && (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LocationsOverview
              locations={data.locations}
              getLocationIcon={getLocationIcon}
              getLocationTypeColor={getLocationTypeColor}
            />

            <TransportRoutes routes={data.routes} formatNumber={formatNumber} />
          </div>

          <LocationStatistics locationsByType={locationsByType} formatNumber={formatNumber} />
        </>
      )}

      <InteractiveMapPlaceholder />
    </div>
  );
}
